<!-- update-optional-confirm-dialog.component.html -->

<div class="uoc-dialog">

  <!-- Header -->
  <div class="uoc-header">
    <div class="uoc-header-left">
      <span class="uoc-lock-icon material-icons">{{ 'leave_management.update_optional_confirm_dialog.lock' | transloco }}</span>
      <h2 class="uoc-title">{{ 'leave_management.update_optional_confirm_dialog.are_you_sure_you_want_to_change_the' | transloco }}</h2>
    </div>
    <button class="uoc-close" (click)="onCancel()">{{ 'leave_management.update_optional_confirm_dialog.x2715' | transloco }}</button>
  </div>

  <div class="uoc-divider"></div>

  <!-- Body -->
  <div class="uoc-body">
    <p class="uoc-message">
      {{ 'leave_management.update_optional_confirm_dialog.you_need_to_re_submit_your_new_optional' | transloco }}
    </p>
  </div>

  <!-- Footer -->
  <div class="uoc-actions">
    <button class="lm-btn lm-btn--outline" (click)="onCancel()">{{ 'leave_management.update_optional_confirm_dialog.cancel' | transloco }}</button>
    <button class="lm-btn lm-btn--primary" (click)="onConfirm()">{{ 'leave_management.update_optional_confirm_dialog.confirm' | transloco }}</button>
  </div>

</div>
